import { render, staticRenderFns } from "./FormFornitore.vue?vue&type=template&id=4dfa4b90&scoped=true"
import script from "./FormFornitore.vue?vue&type=script&lang=js"
export * from "./FormFornitore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa4b90",
  null
  
)

export default component.exports